"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    attach: function () { },
    detach: function () { },
};
